import { Spin } from 'antd';
import { darkenHex } from './utils.js';
import ApplicationCard from './ApplicationCard.jsx';

function ApplicationsPanel({
	referrals,
	loading,
	accentColor,
	onViewAll,
}) {
	return (
		<aside
			className="rounded-2xl bg-white"
			style={{
				border: '1px solid #f1f5f9',
				padding: 20,
				boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
			}}
		>
			<div
				className="flex items-center justify-between"
				style={{ marginBottom: 14 }}
			>
				<h2
					style={{
						fontSize: 16,
						fontWeight: 600,
						color: '#1e293b',
						margin: 0,
					}}
				>
					Your Applications
				</h2>
				<button
					type="button"
					onClick={onViewAll}
					style={{
						background: 'none',
						border: 'none',
						color: accentColor,
						fontSize: 12,
						fontWeight: 600,
						cursor: 'pointer',
						padding: 0,
						transition: 'color 0.2s',
					}}
					onMouseOver={(e) => {
						e.currentTarget.style.color = darkenHex(accentColor);
					}}
					onMouseOut={(e) => {
						e.currentTarget.style.color = accentColor;
					}}
				>
					View All
				</button>
			</div>

			{loading ? (
				<div
					className="flex items-center justify-center"
					style={{ padding: '20px 0' }}
				>
					<Spin size="small" />
				</div>
			) : referrals.length === 0 ? (
				<p
					style={{
						fontSize: 13,
						color: '#475569',
						margin: 0,
						textAlign: 'center',
						padding: '20px 0',
					}}
				>
					No applications yet
				</p>
			) : (
				<div className="flex flex-col gap-3">
					{referrals.slice(0, 5).map((referral) => (
						<ApplicationCard
							key={referral.id}
							referral={referral}
							accentColor={accentColor}
						/>
					))}
				</div>
			)}
		</aside>
	);
}

export default ApplicationsPanel;
